export default "__VITE_ASSET__DAwSY9_5__"